import React from 'react';
import { useRoomStore } from '@store/roomStore';
import styles from './RoomInfo.module.css';

export const RoomInfo: React.FC = () => {
  const roomCode = useRoomStore((state) => state.roomCode);
  const opponent = useRoomStore((state) => state.opponent);
  
  const copyRoomCode = () => {
    if (roomCode) {
      navigator.clipboard.writeText(roomCode);
      // You could add a toast notification here
    }
  };
  
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Room Info</h3>
      
      <div className={styles.info}>
        <label className={styles.label}>Room Code:</label>
        <div className={styles.codeWrapper}>
          <span className={styles.code}>{roomCode}</span>
          <button
            onClick={copyRoomCode}
            className={styles.copyButton}
            title="Copy room code"
          >
            📋
          </button>
        </div>
      </div>
      
      <div className={styles.info}>
        <label className={styles.label}>Opponent:</label>
        <span className={styles.value}>
          {opponent ? opponent.name : 'Waiting...'}
        </span>
        {opponent && (
          <span className={`${styles.status} ${opponent.connectionStatus === 'connected' ? styles.connected : styles.disconnected}`}>
            {opponent.connectionStatus === 'connected' ? '🟢' : '🔴'}
          </span>
        )}
      </div>
    </div>
  );
};